import { registerRootComponent } from "expo";
import App from "./App";

// registerRootComponent calls AppRegistry.registerComponent
// It also ensures that you render the popular React Native content
// container called ExpoRoot.
registerRootComponent(App);

